// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-input-btn[data-v-629adbac] .ant-input-group-addon {\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n.btnFile[data-v-629adbac] {\n  border: none;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btnBox[data-v-629adbac] {\n  margin: 100px 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}", ""]);
// Exports
module.exports = exports;
